import Icon from '@icon/Icon';

const Notes = (props) => {
  const { color, ...rest } = props;

  return (
    <Icon {...rest} viewBox="0 0 32 32">
      <path
        opacity="0.2"
        d="M26.9642 7.02028C28.6629 8.02475 29.4502 10.0633 28.8326 11.9377C28.0256 14.3869 26.8697 17.7588 25.8341 20.2719C25.1772 21.8659 24.5617 23.1314 24.0427 24.0985C23.1963 25.6759 21.3837 26.3144 19.6483 25.8753C15.43 24.8082 11.3827 23.1408 7.63725 20.9261C6.09411 20.0137 5.25854 18.2802 5.76984 16.5619C6.08314 15.509 6.53741 14.1781 7.1921 12.5894C8.22386 10.0858 9.78157 6.87373 10.9363 4.56312C11.8185 2.79759 13.8135 1.90525 15.7269 2.38932C19.6746 3.38803 23.4591 4.94768 26.9642 7.02028Z"
        fill="#FDB858"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3153 5.32229C22.2437 5.57659 23.744 7.12496 23.8933 9.06431C24.0584 11.2095 24.2338 13.9973 24.2338 16.161C24.2338 18.3248 24.0584 21.1126 23.8933 23.2578C23.744 25.1971 22.2437 26.7455 20.3153 26.9998C16.6816 27.479 13.0004 27.479 9.36668 26.9999C7.43805 26.7455 5.93793 25.1966 5.78875 23.257C5.62348 21.1083 5.44775 18.3168 5.44775 16.161C5.44775 14.0053 5.62348 11.2138 5.78875 9.06506C5.93793 7.12546 7.43806 5.57656 9.36668 5.32224C13.0004 4.84307 16.6816 4.84312 20.3153 5.32229ZM8.33792 14.716C8.33792 13.9179 8.98491 13.2709 9.783 13.2709H19.8986C20.6967 13.2709 21.3437 13.9179 21.3437 14.716C21.3437 15.5141 20.6967 16.161 19.8986 16.161H9.783C8.98491 16.161 8.33792 15.5141 8.33792 14.716ZM9.783 17.6061C8.98491 17.6061 8.33792 18.2531 8.33792 19.0512C8.33792 19.8493 8.98491 20.4963 9.783 20.4963H12.6732C13.4713 20.4963 14.1183 19.8493 14.1183 19.0512C14.1183 18.2531 13.4713 17.6061 12.6732 17.6061H9.783Z"
        fill="#FDB858"
      />
    </Icon>
  );
};

export default Notes;
